import { createContext, useContext, useState, useCallback } from 'react';

const WizardContext = createContext(null);

const initialState = {
  step: 1,
  totalSteps: 3,
  data: {
    // Step 1: Location
    country_now: 'Brasil',
    nationality: 'Brasil',
    destination_country: '',
    city: '',
    inside_spain: false,
    inside_eu: false,
    // Step 2: Goal
    goal: '',
    // Step 3: Family
    family: {
      total: 1,
      adults: 1,
      children: 0,
      ages: []
    },
    // Step 4: Finance
    finance: {
      budget_range: '',
      income_range: '',
      has_contract: false,
      has_housing: false,
      has_empadronamiento: false,
      has_health_insurance: false
    },
    // Step 5: Free text
    free_text: '',
    // Step 6: Contact
    name: '',
    email: '',
    whatsapp: ''
  }
};

export const WizardProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState(null);

  const updateData = useCallback((updates) => {
    setState(prev => ({
      ...prev,
      data: {
        ...prev.data,
        ...updates
      }
    }));
  }, []);

  const updateFamily = useCallback((updates) => {
    setState(prev => ({
      ...prev,
      data: {
        ...prev.data,
        family: {
          ...prev.data.family,
          ...updates
        }
      }
    }));
  }, []);

  const updateFinance = useCallback((updates) => {
    setState(prev => ({
      ...prev,
      data: {
        ...prev.data,
        finance: {
          ...prev.data.finance,
          ...updates
        }
      }
    }));
  }, []);

  const nextStep = useCallback(() => {
    setState(prev => ({
      ...prev,
      step: Math.min(prev.step + 1, prev.totalSteps)
    }));
  }, []);

  const prevStep = useCallback(() => {
    setState(prev => ({
      ...prev,
      step: Math.max(prev.step - 1, 1)
    }));
  }, []);

  const goToStep = useCallback((step) => {
    setState(prev => ({
      ...prev,
      step: Math.max(1, Math.min(step, prev.totalSteps))
    }));
  }, []);

  const reset = useCallback(() => {
    setState(initialState);
    setPreview(null);
    setError(null);
  }, []);

  const value = {
    ...state,
    updateData,
    updateFamily,
    updateFinance,
    nextStep,
    prevStep,
    goToStep,
    reset,
    isSubmitting,
    setIsSubmitting,
    preview,
    setPreview,
    error,
    setError
  };

  return (
    <WizardContext.Provider value={value}>
      {children}
    </WizardContext.Provider>
  );
};

export const useWizard = () => {
  const context = useContext(WizardContext);
  if (!context) {
    throw new Error('useWizard must be used within a WizardProvider');
  }
  return context;
};

export default WizardContext;
